import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';

export const KINDS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  SIGNAL: 'signal',
  INFO: 'info',
  ERROR: 'error',
};

const kinds = {
  [KINDS.PRIMARY]: 'bg-blue-100 text-blue-800',
  [KINDS.SECONDARY]: 'bg-slate-100 text-slate-800',
  [KINDS.SUCCESS]: 'bg-green-100 text-green-900',
  [KINDS.SIGNAL]: 'bg-teal-100 text-teal-800',
  [KINDS.INFO]: 'bg-amber-200 text-amber-900',
  [KINDS.ERROR]: 'bg-red-100 text-red-800',
};

const InfoBanner = ({ kind = KINDS.PRIMARY, className, children, onClick }) => {
  const cn = useClassNames(() => [kinds[kind], className], [className, kind]);

  return (
    <div data-component="InfoBanner" className={cn} onClick={onClick} aria-hidden="true">
      {children}
    </div>
  );
};

InfoBanner.propTypes = {
  children: PropTypes.node.isRequired,
  kind: PropTypes.oneOf(Object.values(KINDS)).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  onClick: PropTypes.func,
};

InfoBanner.defaultProps = {
  className: '',
  onClick: () => {},
};

export default InfoBanner;
